import { useEffect, useState } from "react";
import styles from "./deletebox.module.scss";
const DeleteBox = ({ deleteFunction, isSuccess, isError, contentName, setShowDeleteModal }) => {
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    if (isSuccess) {
      setLoader(false);
    }
  }, [isSuccess]);

  const handleDeletion = () => {
    setLoader(true);
    deleteFunction()
  }

  return (
    <div
      className={`container-background content-center ${styles.deleteBoxContainer}`}
    >
      <div className={styles.deleteBox}>
        <p className={styles.boxTitle}>Are you sure you want to delete <b>"{contentName}"</b> ?</p>
        <p className={styles.boxSubtitle}>This will permanently delete it. You cannot undo this action.</p>
        {isError && <p className={styles.deleteError}>Error Deleting {contentName}, Please try again!</p>}
        <div className={styles.deleteBoxBtns}>
          <button
            className={styles.cancelBtn}
            onClick={() => {
              setShowDeleteModal(false);
            }}
          >
            Cancel
          </button>

          <button
            disabled={loader}
            className={styles.deleteBtn}
            onClick={handleDeletion}>
            {loader ? 'Deleting...' : 'Delete'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteBox;
